import ImageLink from "../image-link/ImageLink";
import './SocialIcon.css'

export default function SocialLink({name, link, icon}) {
    return (
        <li className="social-link">
            <ImageLink link={link} image={icon} imageAlt={name + "icon"} hasShadow={false} hasBackground={true} hasLink={true}/>
        </li>
    )
}